<script>
  import MediaFipeTable from './media-fipe-comitentes/table'

  export default {
    name: 'relatorio-basico-media-comitentes',
    props: ['data', 'all', 'sucatas', 'salvados', 'period'],
    data () {
      return {
        // mostrarTotal: true,
        mostrarSalvados: true,
        mostrarSucatas: true,
        filtroComitente: ''
      }
    },
    computed: {
      mostrarTotal () {
        return this.mostrarSalvados && this.mostrarSucatas
      },
      comitentes () {
        return this.data.map((v) => {
          return v.nome
        })
      },
      filteredData () {
        let data = this.data
        if (this.filtroComitente !== '') {
          data = data.filter((v) => v.nome === this.filtroComitente)
        }
        return data
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      an (v) {
        return Math.round(Number(v))
      },
      semAno (v) {
        return String(v.slice(0, -5))
      },
      print () {
        window.print()
      },
      leiloesCData (l) {
        let leiloes = []
        let type
        l.forEach((v) => {
          leiloes.push({type: 'header', data: v.data})
          type = 'salvados'
          leiloes.push({
            type: 'Salvados',
            data: v.data,
            quantidade: v[`${type}Quantidade`],
            vendidos: v[`${type}Vendidos`],
            percentualVenda: v[`${type}PercentualVenda`],
            percentualFipe: v[`${type}PercentualFipe`]
          })
          type = 'sucatas'
          leiloes.push({
            type: 'Sucatas',
            data: v.data,
            quantidade: v[`${type}Quantidade`],
            vendidos: v[`${type}Vendidos`],
            percentualVenda: v[`${type}PercentualVenda`],
            percentualFipe: v[`${type}PercentualFipe`]
          })
          leiloes.push({
            type: 'Total',
            data: v.data,
            quantidade: v[`quantidade`],
            vendidos: v[`vendidos`],
            percentualVenda: v[`percentualVenda`],
            percentualFipe: v[`percentualFipe`]
          })
        })
        return leiloes
      }
    },
    components: {MediaFipeTable},
    filters: {
      translate (v) {
        return v === 'Salvados' ? 'Veiculos' : v
      }
    }
  }
</script>

<template>
  <div class="result bg-white a4">
    <div class="result-title hidden-print__no">
      <h1>RELATÓRIO MÉDIA DE RECUPERAÇÃO X FIPE POR COMITENTES</h1>
      <h3>{{period}}</h3>
      <div class="text-center hidden-print">
        <!--<input type="checkbox" v-model="mostrarTotal"> Mostrar total-->
        <input type="checkbox" v-model="mostrarSalvados"> Mostrar veículos
        <input type="checkbox" v-model="mostrarSucatas"> Mostrar sucatas
        <div>Filtrar por comitente:
          <select v-model="filtroComitente">
            <option value="">Sem filtro</option>
            <option v-for="comitente in comitentes" :value="comitente">{{comitente}}</option>
          </select>
        </div>
      </div>
      <div class="text-center hidden-print">
        <a @click="print"><i class="fa fa-print"></i> imprimir <span class="font-thin">(CTRL + P)</span></a>
      </div>
    </div>
    <div class="c-result printer-page__no" v-for="comitente in filteredData">
      <!--<div class="result-title">
        <h1 class="visible-print">RELATÓRIO MÉDIA DE RECUPERAÇÃO X FIPE POR COMITENTES</h1>
        <h3 class="visible-print">{{period}}</h3>
      </div>-->
      <h3 class="comitente-nome text-uppercase">{{comitente.nome}}</h3>
      <table class="tbl-result2">
        <tr>
          <th>Data</th>
          <th>Quantidade</th>
          <th>Vendidos</th>
          <th>% Venda</th>
          <th>% FIPE</th>
        </tr>
        <tr v-for="leilao in leiloesCData(comitente.leiloes)" v-if="(leilao.type === 'Salvados' && mostrarSalvados) || (leilao.type === 'Sucatas' && mostrarSucatas) || (leilao.type === 'Total' && mostrarTotal) || leilao.type === 'header'">
          <td class="font-bold" v-if="leilao.type==='header'"><div class="m-t-xs">{{semAno(leilao.data)}}</div></td>
          <td v-if="leilao.type==='header'"></td>
          <td v-if="leilao.type==='header'"></td>
          <td v-if="leilao.type==='header'"></td>
          <td v-if="leilao.type==='header'"></td>
          <td v-if="leilao.type!='header'">{{leilao.type|translate}}</td>
          <td v-if="leilao.type!='header'">{{leilao.quantidade}}</td>
          <td v-if="leilao.type!='header'">{{leilao.vendidos}}</td>
          <td v-if="leilao.type!='header'">{{an(leilao.percentualVenda)}}%</td>
          <td v-if="leilao.type!='header'">{{an(leilao.percentualFipe)}}%</td>
        </tr>
        <tr>
          <td colspan="5" class="text-left">
            *Média (%) de Venda / Fipe: <strong>{{an(comitente.salvadosMediaPeriodoFipe)}}%</strong>
          </td>
        </tr>
        <tr>
          <td colspan="5" class="text-left">
            *Média (%) de Veículos Vendidos: <strong>{{an(comitente.mediaPeriodoVendidos)}}%</strong> <!-- salvadosMediaPeriodoVendidos -->
          </td>
        </tr>
        <!--<media-fipe-table :comitente="comitente" type="salvados" v-if="mostrarSalvados"/>
        <media-fipe-table :comitente="comitente" type="sucatas" v-if="mostrarSucatas"/>-->
      </table>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// ResultMediaFipeComitentes.vue?57f5f30f